import { PureComponent } from "react";
import IEducationalBookletDetailsState, { IEducationalBookletDetailsProps } from "./EducationalBookletDetails.models";
import BookletsService from "../../../services/education/BookletsService";
import { toast } from "react-toastify";
import { BookLetsEditionView } from "../../../models/views/education/BookLetsEditionView";
import { BookletType } from "../../../models/interfaces/education/BookletType";
import VideoThumbnails from "../../shared/react-thumbnail/thumbnail";
import BookletDetailsImg from "../../../assest/images/card-image/booklet-details.png";
import './EducationalBookletDetails.scss'

export default class EducationalBookletDetails extends PureComponent<IEducationalBookletDetailsProps, IEducationalBookletDetailsState>{
    bookletsService: BookletsService;
    constructor(props: any) {
        super(props);
        this.bookletsService = new BookletsService();
        this.state = { showVideo: false };
    }

    componentDidMount() {
        this.getById();
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.id !== this.props.id)
            this.getById();
    }

    getById = () => {
        let self = this;
        let bookletsService = self.bookletsService;

        if (self.props.id !== null && self.props.id !== undefined)
            bookletsService.getById(self.props.id, true).then(function (response) {
                self.setState({ booklet: response });
            });
    }

    createBookMark = () => {
        this.bookletsService.createBookMark(this.props.id as number).then(response => {
            toast.success("با موفقیت نشانه گزاری شد.");
            this.getById();
        }).catch(error => {
            toast.error("خطا در نشانه گزاری جزوه.");
        });
    }

    deleteBookMark = () => {
        this.bookletsService.deleteBookMark(this.props.id as number).then(response => {
            toast.success("با موفقیت از موارد نشان شده حذف شد.");
            this.getById();
        }).catch(error => {
            toast.error("خطا در حذف نشانه گزاری جزوه.");
        });
    }

    render(): React.ReactNode {
        let { booklet } = this.state;

        let file;
        if (booklet?.bookletType === BookletType.File) {
            if (booklet?.fileContentType?.includes("video"))
                file = (<>{this.videoView(booklet)}</>)
            else if (booklet.fileContentType?.includes("audio"))
                file = (<>{this.audioView(booklet)}</>)
            else
                file = (<>{this.nonVideoView(booklet)}</>)
        }
        else file = (<></>);

        ;
        return (<div className="educational-booklet-details">
            <div className="pt-2 pb-2 d-flex justify-content-between align-items-center">
                <span className="font-bold booklet-title">
                    <img src={BookletDetailsImg} />
                    <span className="p-1">{booklet?.title}</span>
                </span>
                {
                    booklet?.hasBookMarked === true ?
                        <span className="mdi mdi-bookmark booklet-icon" onClick={this.deleteBookMark}></span>
                        :
                        <span className="mdi mdi-bookmark-outline booklet-icon" onClick={this.createBookMark}></span>
                }
            </div>
            <div>
                {
                    (booklet?.fileAttachmentId) && <video controls>
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet?.fileAttachmentId}`} type="video/webm" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet?.fileAttachmentId}`} type="video/ogg" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet?.fileAttachmentId}`} type="video/mp4" />
                    </video>
                }
            </div>
            <div className={`pt-1 pb-1 ${booklet?.fileAttachmentId && ' booklet-description'}`}>
                {booklet?.description}
            </div>
            <div className="pt-1 pb-1">
                <span>مدرس: </span>
                <span>
                    {booklet?.authorFullName}
                </span>
            </div>
        </div>);
    }

    nonVideoView(booklet: BookLetsEditionView) {
        return <>
            <div className="col-12 tk-padding-top">
                <div className="tk-card" style={{ height: "70px" }}>
                    <div className="col-12">
                        <div className="row tk-padding-top">
                            <div className="col-5 notspace" style={{ textAlign: "left" }}>
                                <label style={{ color: "#6cb4ff", paddingLeft: "10px", fontSize: "25px" }} className="mdi mdi-file-document"></label>
                            </div>
                            <div className="col-7 notspace">
                                <a href={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} target="_blank" rel="noreferrer" style={{ paddingTop: "8px" }}>دانلود فایل</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    videoView(booklet: BookLetsEditionView) {
        let content;
        if (this.state.showVideo) {
            content = <>
                {
                    <video style={{ width: "100%" }} height="185" controls>
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/webm" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/ogg" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/mp4" />
                    </video>
                }
            </>
        }
        else
            content = <>
                <VideoThumbnails width={620} height={844} videoUrl={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} />
                <i className="play-icon mdi mdi-play-circle-outline"></i>
            </>;

        return <>
            <div className="EducationBookletModalArea video-contet" onClick={() => this.setState({ showVideo: true })}>
                {content}
            </div>
        </>
    }

    audioView(booklet: BookLetsEditionView) {
        return <>
            <div style={{ textAlign: 'center' }}>
                {
                    <audio style={{ width: "100%" }} controls>
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/wav" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/ogg" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                }
            </div>
        </>
    }

    imageView(booklet: BookLetsEditionView) {
        return <>
            <div style={{ textAlign: 'center' }}>
                {
                    <img src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} alt="coaching image" />
                }
            </div>
        </>
    }
}